import cx from 'classnames'
import { useCallback, useMemo, useState } from 'react'

import { type ItemPropsWithId } from '@frame-builder/lib/item'

import Item from './item'

export interface ItemListProps {
  items: ItemPropsWithId[]
  defaultValue?: string
  onChange?: (id: string) => void
  className?: string
}

const ItemList = ({
  items,
  defaultValue,
  onChange,
  className,
}: ItemListProps) => {
  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue)

  const handleClick = useCallback(
    (item: ItemPropsWithId) => {
      // Ignore disabled items and selected item
      if (item.disabled || item.id === selectedId) {
        return
      }

      setSelectedId(item.id)

      if (onChange) {
        onChange(item.id)
      }
    },
    [onChange, selectedId],
  )

  const sortedItems = useMemo(() => {
    // Sort items by disabled status
    return items.sort((item1, item2) => {
      return !item1.disabled && item2.disabled
        ? -1
        : item1.disabled && !item2.disabled
          ? 1
          : 0
    })
  }, [items])

  return (
    <div className={cx('flex flex-col w-full space-y-2.5', className)}>
      {sortedItems.map((item) => (
        <Item
          key={`${item.id}`}
          selected={item.id === selectedId}
          onClick={() => handleClick(item)}
          title={item.title}
          imageElement={item.imageElement}
          subtitleElement={item.subtitleElement}
          descriptionElement={item.descriptionElement}
          detailsElement={item.detailsElement}
          badgeElement={item.badgeElement}
          disabled={item.disabled}
          error={item.error}
          className={item.className}
        />
      ))}
    </div>
  )
}

export default ItemList
